import React, { Component } from 'react';
import _ from 'lodash';
import { Row, Tabs, Col, Card, Spin, Icon} from 'antd';
import Highstock from 'highcharts/highstock';
import ReactHighcharts from 'react-highcharts'; 
import Activities from './Activities'
import axios from 'axios';
import { analyticsApi } from '../../../services';
import { handleAppError } from '../../handlers';
const Charts = ReactHighcharts.withHighcharts(Highstock);
let token =''
const TabPane = Tabs.TabPane;

class Stress extends Component {
  constructor(props) {
      super(props);
      this.state = {
        loading: false,
        data: {},
        contractId : null,
        startDate: null,
        endDate: null,
        baseConfig : {
          filters: [],
          config: {
            chart: {},
            title: {text: '', align: 'left'},
            subtitle: { text: '', align: 'left' },
            xAxis: {},
            yAxis: {
                  labels: {
                    formatter: function() {
                      return this.value + ' %';
                    }
                  },
                  max: 100
                },
            credits: {
              enabled: false
            },
            series: []
          }
        }
      };
  }

  componentDidMount () {
    let that = this;
    this.setState({loading: true, contractId: this.props.contractId, startDate: this.props.startDate, endDate: this.props.endDate})
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.contractId && prevState.contractId !== this.state.contractId) {
      token && token.cancel();
      this.fetchCompleteData(this.state.contractId, this.state.startDate, this.state.endDate);
    }
  }

  fetchCompleteData = (contractId, startDate, endDate) => {
    token = axios.CancelToken.source();
    analyticsApi.getStressAnalytics({contractId, startDate, endDate, cancelToken: token.token}, 
      (resp)=>{
        let fetchData = resp.data 
        this.setState({
          data: fetchData,loading: false})
      },
      (err)=>{
       handleAppError(err)
      })
  }

 

  renderDonutChart(){
    let that = this
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    baseConfig.config.chart = { type: 'pie',
                                height: 300
                              }    

    baseConfig.config.tooltip = { 
                                  style: {color: '#a1a1a1'},
                                  pointFormat: '<span style="color:{point.color}">{point.percentage:.1f}%</span>',
                                  backgroundColor: '#4d6189',
                                  borderColor: 'none'}
    baseConfig.config.plotOptions = {
      pie: {
        allowPointSelect: true,
            cursor: 'pointer',
            colors: ['#ff6969','#ffb500','#35cb7f'],
            dataLabels: {
                enabled: false
            }
      }
    }
    baseConfig.config.series = [{ name: 'h',
                                  data: that.state.data.charts_data.all.series,
                                  size: '60%',
                                  innerSize: '60%'}]
    return(
      <div>
        <Charts 
          config={baseConfig.config}/>
          <Row>
            <Col span={24} style={{paddingRight: 10,paddingLeft: 70}}>
              <Col sm={8}>
                <Row type="flex" justify="start">
                  <svg height="12" width="13">
                    <rect x="0" y="0" width="13" height="12" rx="6" ry="6" style={{fill: '#ff6969'}}/>
                  </svg>  
                  <h6 className="web-login-track mt-minus-9">High Stress</h6>
                </Row>
                <Row type="flex" justify="start">
                  <h2 className="number-style">{that.state.data.charts_data.all["High Stress"]}</h2>
                </Row>
              </Col>
              <Col sm={8}>
                <Row type="flex" justify="start">
                  <svg height="12" width="13">
                    <rect x="0" y="0" width="12" height="12" rx="6" ry="6" style={{fill: '#ffb500'}}/>
                  </svg>  
                  <h6 className="web-login-track mt-minus-9">Medium Stress</h6>
                </Row>
                <Row type="flex" justify="start">
                  <h2 className="number-style">{that.state.data.charts_data.all["Medium Stress"]}</h2>
                </Row>
              </Col>
              <Col sm={8}>
                <Row type="flex" justify="start">
                  <svg height="12" width="13">
                    <rect x="0" y="0" width="13" height="12" rx="6" ry="6" style={{fill: '#35cb7f'}}/>
                  </svg>  
                  <h6 className="web-login-track mt-minus-9">Low Stress</h6>
                </Row>
                <Row type="flex" justify="start">
                  <h2 className="number-style">{that.state.data.charts_data.all["Low Stress"]}</h2>
                </Row>
              </Col>
            </Col>
          </Row>  
      </div>
    )
  }

  renderComorbiditiesChart(record){
    let that = this
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    baseConfig.config.chart= { type: 'column',
                               height: 300
                              } 
    baseConfig.config.tooltip = { pointFormat: '<span>Employees percentage</span>: <span style="color:{point.color}">{point.y}%</span>',
                                  style: {color: '#a1a1a1'},
                                  backgroundColor: '#4d6189',
                                  borderColor: 'none'}                          
    baseConfig.config.yAxis.title = {text: "% Of Employees"}
    baseConfig.config.xAxis = {categories: record.xkeys
                              } 

    baseConfig.config.series = [{ showInLegend: false,data: record.series,color: 'white',states: {
                hover: {
                    enabled: false
                }
            }}]
    baseConfig.config.plotOptions = {column: {maxPointWidth: 21,events: {
            legendItemClick: function () {
                return false; 
            }
        }}}
    let a = record.series
        if (a.length > 0){
          let b = a.map(a => a.y)
          b = Array.prototype.concat(...b)
          b = b.filter( item => item ) // this will delete undefined from array
          b = b.filter( item => isNaN(item) == false) // this will remove alphanumerics from array
          if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
        }
    return(
      <div style={{marginTop: 15}}>
        <Charts 
          config={baseConfig.config}/>
      </div>
    )
  }

  renderDistributionChart(record,no_data,text,tab){
    let that = this
    let maxBarsToShow = text === "gender" ? 2 : (record.xkeys.length > 2 ? 4 : 1)
    let showScrollBar = text === "gender" ? false : (record.xkeys.length > 2 ? true : false)
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    baseConfig.config.chart= { type: 'column'
                              } 

    baseConfig.config.yAxis.title = {text: "% Of Employees"}
    baseConfig.config.xAxis = {categories: record.xkeys,
                                min: 0,
                                max: maxBarsToShow,
                                scrollbar: {enabled: showScrollBar,
                                            barBackgroundColor: '#e8e8e8',
                                            barBorderColor: '#e8e8e8',
                                            barHeight: '15px',
                                            buttonBackgroundColor: '#ffffff',
                                            buttonBorderColor: '#e8e8e8',
                                            backgroundColor: '#f4f4f4'}
                              }
    baseConfig.config.tooltip = { 
                                    formatter: function() {
                                      var text =  tab + ': <span style="font-family: ProximaNova-Semibold">' + this.x + '</span><br>' + this.series.name + `: <span style="color:${this.color}">` + this.y + '%</span>'
                                      return text;
                                  },
                                  style: { color: '#a1a1a1' },
                                  backgroundColor: '#4d6189',
                                  borderColor: 'none',
                                }                       
    baseConfig.config.series = record.series
    baseConfig.config.plotOptions = {column: {maxPointWidth: 21,events: {
            legendItemClick: function () {
                return false; 
            }
        }}}
    let a = record.series
        if (a.length > 0){
          let b = a.map(a => a.data)
          b = Array.prototype.concat(...b)
          b = b.filter( item => item ) // this will delete undefined from array
          b = b.filter( item => isNaN(item) == false) // this will remove alphanumerics from array
          if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
        }    
    return(
      <div>
        <Card className="health-check-utilization-card" style={{marginBottom: 20,marginTop: 10}}>
          <div style={{marginTop: 15}}>
            <Charts 
              config={baseConfig.config}/>
          </div>    
        </Card>    
        <Row type="flex" justify="start">
          <h5 className="health-check-note"><Icon type="info-circle" theme="filled" style={{color: '#70411b'}}/>&nbsp;Active Employees who haven’t provided {text} : <span className="semibold ml-1">{no_data}</span></h5>
        </Row>
      </div>
    )
  }

  render () {
    let that = this
    if(that.state.loading || Object.keys(that.state.data).length === 0 ){
      return(
        <div className="spiner">
          <Spin size="large"/>
        </div>
      )
    }else if(that.state.data.charts_data.all.Total === 0){
      return(
        <div>
          <Row>
          <Col span={12}>
            <Card className="health-check-utilization-card" style={{marginBottom: 20,marginTop: 10,marginRight: 10}}>
              <h3 className="font-semibold">Stress Analysis</h3>
              <h5 style={{color: '#8c9197', marginBottom: 100}}>The data shows how the stress of your employees is distributed under high stress, medium stress, and low stress.</h5>
              <Row className="footer-card" style={{top: 120}}>
                <Row type="flex" justify="start" style={{marginTop: 12,marginLeft: 24}}>
                  <h4 className="font-semibold">The selected lifestyle data is not provided by employees</h4>
                </Row>
                <Row type="flex" justify="start" style={{marginTop: 3,marginLeft: 24,marginBottom: 6}}>
                  <h5 className="zero-state-body-text" style={{marginTop: '-10'}}>Reach out to your customer success manager <span className="semibold" style={{color: '#2168f3'}}>{sessionStorage.getItem('hr_contact_email')}</span> to learn more on whow to encourge employees to take HRA.</h5>
                </Row>
              </Row>
            </Card>
          </Col>
          </Row>
        </div>
      )
    }else{
      return(
        <div>  
        <Row>
          <Col span={12}>
            <Card className="health-check-utilization-card" style={{marginBottom: 20,marginTop: 10,marginRight: 10,minHeight: 523}}>
              <h3 className="font-semibold">Stress Analysis</h3>
              <h5 style={{color: '#8c9197', marginBottom: 30}}>The data shows how the stress of your employees is distributed under high stress, medium stress, and low stress.</h5>
              <h4 className="semibold" style={{color: '#9b9b9b'}}><span className="semibold" style={{color: '#2168f3'}}>{that.state.data.charts_data.all.Affected}</span> Effected out of <span className="semibold" style={{color: '#4d6189'}}>{that.state.data.charts_data.all.Total}</span></h4>
              {this.renderDonutChart()}
            </Card>
          </Col>
          <Col span={12}>  
            <Card className="health-check-utilization-card" style={{marginBottom: 20,marginTop: 10,marginLeft: 10,minHeight: 523}}>
              <h3 className="font-semibold">Comorbidities with Stress</h3>
              <h5 style={{color: '#8c9197'}}>High Stress can aggravate conditions like hypertension, diabetes, cardiovascular disease, and obesity. By understanding the techniques to handle stress, we can reduce the risk of these lifestyle diseases.</h5>
              <Tabs defaultActiveKey="1">
                <TabPane tab="Hypertensive" key="1">
                  {this.renderComorbiditiesChart(that.state.data.comorb_data.hypertensive)}
                </TabPane>
                <TabPane tab="Diabetic" key="2">
                  {this.renderComorbiditiesChart(that.state.data.comorb_data.diabetic)}
                </TabPane>
                <TabPane tab="CVD" key="3">
                  {this.renderComorbiditiesChart(that.state.data.comorb_data.cvd)}
                </TabPane>
                <TabPane tab="Obese" key="4">
                  {this.renderComorbiditiesChart(that.state.data.comorb_data.obese)}
                </TabPane>
              </Tabs>
            </Card>
          </Col>  
        </Row>
        <Row type="flex" justify="start">
          <h5 className="health-check-note"><Icon type="info-circle" theme="filled" style={{color: '#70411b'}}/>&nbsp;Active Employees who haven’t provided stress data : <span className="semibold ml-1">{that.state.data.missing_data.stress}</span></h5>
        </Row>
        <Activities />
        <Row type="flex" justify="start" style={{marginLeft: 12,marginTop: 30}}>
          <h4 className="sub-heading-title" style={{color: '#8c9197',marginLeft: 0,marginTop: 7}}>STRESS DISTRIBUTION BY</h4>
        </Row>
        <Tabs defaultActiveKey="1">
          <TabPane tab="Age" key="1">
            {this.renderDistributionChart(that.state.data.charts_data.Age,that.state.data.missing_data.age,"date of birth", 'Age')}
          </TabPane>
          <TabPane tab="Gender" key="2">
            {this.renderDistributionChart(that.state.data.charts_data.Gender,that.state.data.missing_data.gender,"gender", 'Gender')}
          </TabPane>
           <TabPane tab="Department" key="3">
            {this.renderDistributionChart(that.state.data.charts_data.Department,that.state.data.missing_data.department,"department", 'Department')}
          </TabPane>
           <TabPane tab="Location" key="4">
            {this.renderDistributionChart(that.state.data.charts_data.Location,that.state.data.missing_data.location,"location", 'Location')}
          </TabPane>
        </Tabs>
        </div>
      )
    }
  }    
}
export default Stress;